export const MIN_VALUE_LENGTH = 3;